import { useEffect, useState } from "react"
import clienteAxios from "../../../configAxios/configAxios"


export const useOutlet = (filtro) => {
    const [vehiculos, setVehiculos] = useState([]);
    const [error, setError] = useState(false);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const AC = new AbortController();
        if (filtro) {
            const getVehiculos = async () => {
                try {
                    setLoading(true);
                    let response = await clienteAxios.post('Modelo/filtro', filtro);

                    if (response.status === 200) {
                        let data = response.data.data;
                        setLoading(false);
                        setVehiculos(data);
                        return
                    }

                    setLoading(false);
                    setError(true);
                } catch (error) {
                    setLoading(false);
                    setError(true);
                }
            }
            getVehiculos();
        }

        return () => AC.abort();

    }, [filtro])

    return [vehiculos, error, loading, setVehiculos]
}

export const useCategorias = () => {
    const [categorias, setCategorias] = useState([]);
    const [error, setError] = useState(false);
    const [loading, setLoading] = useState(true);


    useEffect(() => {
        const AC = new AbortController();
        const obtenerCategorias = async () => {
            try {
                let response = await clienteAxios.get('Categorias/modulo/MODELOS');

                if (response.status === 200) {
                    let data = response.data.data;

                    setLoading(false);
                    setCategorias(data);
                    return;
                }

                setLoading(false);
                setError(true);
            } catch (error) {
                setLoading(false);
                setError(true);
            }
        }
        obtenerCategorias();

        return () => AC.abort();
    }, []);

    return [categorias, error, loading];
}

export const useSubCategorias = (idCategoria) => {

    const [subCategorias, setSubCategorias] = useState([]);
    const [error, setError] = useState(false);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const AC = new AbortController();
        const fetchSubCategorias = async () => {
            try {
                let response = await clienteAxios.get(`buscarCategoriaPorsubCategoria/${idCategoria}`);

                if (response.status === 200) {
                    let data = response.data.data;

                    setSubCategorias(data);
                    setLoading(false);
                    return;
                }
                setLoading(false);
                setError(true);
            } catch (error) {
                setLoading(false);
                setError(true);
            }
        }
        if (idCategoria !== undefined) {
            fetchSubCategorias();
        }

        return () => AC.abort();
    }, [idCategoria])

    return [subCategorias, error, loading];
}

export const useTodosOutlet = () => {
    const [articulos, setArticulos] = useState([])
    const [error, setError] = useState(false);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const AC = new AbortController();
        const fetchTodos = async () => {
            try {
                let response = await clienteAxios.get(`Outlet/Todos`);

                if (response.status === 200) {
                    let data = response.data.data;

                    setArticulos(data);
                    setLoading(false);
                    return;
                }
                setLoading(false);
                setError(true);
            } catch (error) {
                setLoading(false);
                setError(true);
            }
        }
        fetchTodos();

        return () => AC.abort();

    }, [])

    return [articulos, error, loading, setArticulos];
}

export const useRepuestos = (filtro) => {
    const [repuestos, setRepuestos] = useState([]);
    const [error, setError] = useState(false);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const AC = new AbortController(); 

        const fetchRepuestos = async () => {
            try {
                setLoading(true);

                let response = await clienteAxios.post('Repuesto/Filtro', filtro);

                if (response.status === 200) {
                    let data = response.data.data;

                    setRepuestos(data);
                    setLoading(false);
                    return
                }

                setLoading(false);
                setError(true);
            } catch (error) {
                setLoading(false);
                setError(true);
            }
        }
        fetchRepuestos();

        return () => AC.abort();
    }, [filtro])

    return { repuestos, error, loading, setRepuestos };
}

export const useCopiaRepuestos = (filtro) => {
    const [copiaRepuestos, setCopiaRepuestos] = useState([]);
    const [error, setError] = useState(false);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const AC = new AbortController(); 

        const fetchRepuestos = async () => {
            try {
                setLoading(true);

                let response = await clienteAxios.post('Repuesto/Filtro', filtro);

                if (response.status === 200) {
                    let data = response.data.data;

                    setCopiaRepuestos(data);
                    setLoading(false);
                    return
                }

                setLoading(false);
                setError(true);
            } catch (error) {
                setLoading(false);
                setError(true);
            }
        }
        fetchRepuestos();

        return () => AC.abort();
    }, [])

    return { copiaRepuestos, error, loading, setCopiaRepuestos };
}

export const useModelos = () => {
    const [modelos, setModelos] = useState([]);
    const [error, setError] = useState(false);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const AC = new AbortController(); 
        const fetchModelos = async () => {
            let filtro = {
                Modelo: "",
                Version: "",
                Anio: 0
            }

            try {
                let response = await clienteAxios.post('Repuesto/Modelos', filtro);

                if (response.status === 200) {
                    let data = response.data.data;

                    setModelos(data);
                    setLoading(false);
                    return
                }

                setLoading(false);
                setError(true);
            } catch (error) {
                setLoading(false);
                setError(true);
            }
        }
        fetchModelos();

        return () => AC.abort();
    }, [])
    return { modelos, error, loading }
}

export const useVersion = (modelo) => {
    const [versiones, setVersiones] = useState([]);
    const [error, setError] = useState(false);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const AC = new AbortController();
        if (modelo) {
            const fetchVersiones = async () => {
                let filtro = {
                    Modelo: modelo,
                    Version: "",
                    Anio: 0
                }

                try {
                    let response = await clienteAxios.post('Repuesto/Modelos', filtro);

                    if (response.status === 200) {
                        let data = response.data.data;

                        setVersiones(data);
                        setLoading(false);
                        return
                    }

                    setLoading(false);
                    setError(true);
                } catch (error) {
                    setLoading(false);
                    setError(true);
                }
            }

            fetchVersiones();
        }
        return () => AC.abort();
    }, [modelo])
    return { versiones, error, loading }
}

export const useAnio = (modelo, version) => {
    const [anios, setAnios] = useState([]);
    const [error, setError] = useState(false);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const AC = new AbortController();
        if (version && modelo) {
            const fetchAnios = async () => {
                let filtro = {
                    Modelo: modelo,
                    Version: version,
                    Anio: 0
                }

                try {
                    let response = await clienteAxios.post('Repuesto/Modelos', filtro);

                    if (response.status === 200) {
                        let data = response.data.data;

                        setAnios(data);
                        setLoading(false);
                        return
                    }

                    setLoading(false);
                    setError(true);
                } catch (error) {
                    setLoading(false);
                    setError(true);
                }
            }

            fetchAnios();
        }
        return () => AC.abort();
    }, [version, modelo])
    return { anios, error, loading }
}

export const useFormConcesionarios = () => {
    const [concesionarios, setConcesionarios] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(false);

    useEffect(() => {
        const AC = new AbortController();
        const fetchConcesionarios = async () => {
            try {
                let response = await clienteAxios.get('Concesionarios/A');

                if (response.status === 200) {
                    let data = response.data.data;

                    setConcesionarios(data);
                    setLoading(false);
                    return
                }
                setLoading(false);
                setError(true);
            } catch (error) {
                setLoading(false);
                setError(true);
            }
        }
        fetchConcesionarios();
        return () => AC.abort();
    }, [])
    return {concesionarios, error, loading}
}

